export enum ImageFitEnum {
	COVER = 'cover',
	CONTAIN = 'contain',
	FILL = 'fill',
	NONE = 'none',
}
